import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect, useMemo, useRef } from 'react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { Loader } from '../../../../Elements/Loader/index.js';
import { Tooltip } from '../../../../Feedback/Tooltip/index.js';
import { ANIMATION_DURATION_MS } from '../../constants.js';
import { useDropdownContext } from '../../context.js';
import { DropdownItemWrapper } from './styled.js';
export const DropdownItem = forwardRef(function DropdownItem({ children, id, icon, tooltip, wrap, isLoading, disabled, closeOnClick = true, last, onClick, dataTestId = 'dropdown-item', isSelected }, ref) {
    const { close } = useDropdownContext();
    const timeoutRef = useRef();
    const handleClick = useCallbackRef((e) => {
        e.stopPropagation();
        if (!isLoading && !disabled && onClick) {
            if (closeOnClick) {
                close();
                timeoutRef.current = window.setTimeout(() => {
                    onClick(e);
                }, ANIMATION_DURATION_MS);
            }
            else {
                onClick(e);
            }
        }
    });
    const containerProps = useMemo(() => ({
        id,
        wrap,
        disabled,
        $last: last,
        onClick: onClick ? handleClick : undefined,
        'data-testid': dataTestId,
        $isSelected: isSelected,
    }), [id, wrap, disabled, last, onClick, handleClick, dataTestId, isSelected]);
    useEffect(() => () => {
        if (timeoutRef.current) {
            window.clearTimeout(timeoutRef.current);
        }
    }, []);
    return (_jsxs(Tooltip, { tooltip: tooltip, placement: 'auto', ref: ref, ContainerComponent: DropdownItemWrapper, containerComponentProps: containerProps, children: [icon, children, isLoading && _jsx(Loader, { cover: true })] }));
});
